export const buildSearchApiUrl = (query, baseUrl = '') => {
  const normalizedBase = baseUrl || 'http://localhost:5000';
  const encodedQuery = encodeURIComponent(query.trim());
  return `${normalizedBase}/api/search?q=${encodedQuery}`;
};
